<div class="inactive-claim-modal">
  <div class="container">
    <!-- Header -->
    <div class="header-title">
      <mat-icon fontSet="material-icons-outlined" class="header-icon">info</mat-icon>
      <h6 class="title-large">{{ customTitle || ('InactiveClaimTitle' | translate) }}</h6>
      <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon fontSet="material-icons-outlined">close</mat-icon>
      </button>
    </div>

    <!-- Content -->
    <div class="content" *ngIf="!isLoading">
      <!-- Custom message if available -->
      <p class="message" *ngIf="customMessage" [style.white-space]="'pre-line'">
        {{ customMessage }}
      </p>

      <!-- Default messages if no custom message and not a withdrawal -->
      <p class="message" *ngIf="!customMessage && !isWithdrawalConfirmed">
        {{ 'InactiveClaimMessage' | translate }}
      </p>

      <!-- Additional info - hidden for withdrawal confirmed -->
      <p class="additional-info" *ngIf="!hideAdditionalInfo">
        {{ 'InactiveClaimAdditionalInfo' | translate }}
      </p>
    </div>

    <!-- Loading state -->
    <div class="content" *ngIf="isLoading">
      <p class="message">Loading...</p>
    </div>

    <!-- Footer Actions -->
    <div class="actions">
      <button class="def-button" (click)="goToFaq()">
        {{ 'FrequentlyAskedQuestions' | translate }}
      </button>
    </div>
  </div>
</div>
